import React, { Dispatch, SetStateAction } from "react";
import { PosicaoCardStyled } from "./styles";
import { Posicao } from "../../../contexts/CarteiraContext";
import { formatCurrency, numberToPercentageWallet } from "../../../utils";

const negativeToPositive = (n: number) => (n < 0 ? n * -1 : n);

const signal = (n: number) => (n > 0 ? "+" : n < 0 ? "-" : "");

const className = (n: number) => (n >= 0 ? "success" : "error");

export const LucroPrejuizo: React.FC<{ n: number; p: number }> = ({ n, p }) => (
  <span className={className(n)}>
    {signal(n)} {formatCurrency(negativeToPositive(n))} ({signal(n)}{" "}
    {numberToPercentageWallet(negativeToPositive(p))})
  </span>
);

interface PosicaoCardProps {
  key: string;
  posicao?: Posicao;
  setHelpModal: Dispatch<SetStateAction<any>>;
}

export const PosicaoHeader = (posicao?: Posicao) => (
  <div className="header">
    <div className="title">
      {posicao?.codigo || "GOOGL"}
      <span className={className(posicao?.lucroPrejuizoDiario || 0)}>
        {signal(posicao?.lucroPrejuizoDiario || 0)}{" "}
        {numberToPercentageWallet(
          negativeToPositive(posicao?.lucroPrejuizoDiarioPercentual || 0)
        )}
      </span>
    </div>
    <div className="posicao">{formatCurrency(posicao?.posicao || 0)}</div>
  </div>
);

export const PosicaoBody = (
  posicao: Posicao,
  setHelpModal: Dispatch<SetStateAction<any>>
) => (
  <>
    <div>Quantidade: {posicao.quantidade}</div>
    <div>Preço atual: {formatCurrency(posicao.precoAtual)}</div>
    {!posicao.hasPosition2019 && (
      <div>Custo médio de compra: {formatCurrency(posicao.custoMedio)}</div>
    )}
    <div>
      Lucro/prejuízo diário:{" "}
      <LucroPrejuizo
        n={posicao.lucroPrejuizoDiario}
        p={posicao.lucroPrejuizoDiarioPercentual}
      />
    </div>
    {!posicao.hasPosition2019 && (
      <div>
        Lucro/prejuízo total:{" "}
        <LucroPrejuizo
          n={posicao.lucroPrejuizoTotal}
          p={posicao.lucroPrejuizoTotalPercentual}
        />
      </div>
    )}
  </>
);

export const PosicaoCard = ({
  key,
  posicao,
  setHelpModal,
}: PosicaoCardProps) => (
  <PosicaoCardStyled key={key} header={PosicaoHeader(posicao)}>
    {posicao ? PosicaoBody(posicao, setHelpModal) : null}
  </PosicaoCardStyled>
);
